export default "__VITE_ASSET__g$Yllmm5__"